<script>
export default {
  methods: {},
  props: ["title"],
  translate25Context: 'troubleshooting'
};
</script>

<template>
  <div class="troubleshooting-page">
    <div class="logo"></div>
    <div class="title">{{ title }}</div>
    <div class="line"></div>
    <slot name="content"></slot>
  </div>
</template>

<style lang="scss">
.troubleshooting-page {
  max-width: 1400px;
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 100px;
  padding: 100px;

  >.logo {
    padding: 10px;
    background-image: url("/vodalys/vfigma/assets/Logo_Vodalys__Black.png");
    background-repeat: no-repeat;
    background-size: contain;
    height: 75px;
  }

  .title {
    font-family: Lato;
    font-size: 32px;
    font-weight: 700;
    color: var--(black);
  }

  >.line {
    height: 2px;
    margin: 16px 32px;
    border-radius: 100%;
    background-color: #DFE5E5;
  }

  >.list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

@media (max-width: 700px) {
  .troubleshooting-page {
    padding: 60px 20px;
  }
}
</style>